<template>
  <div class="prescriberProxyUserDetails">
    <div class="grid py-4" v-if="showProxy">
      <card>
        <template v-slot>
          <div class="flex item-start">
            <div class="flex-shrink-0 content-center"><v-account-group-outline></v-account-group-outline></div>
            <div class="flex-1">
              <div class="text-2xl font-semibold leading-6 flex-1 mx-2">Volmachtgevers</div>
            </div>
          </div>
          <div class="grid my-4">
            <div v-for="(proxy, index) in proxyUserDetails" :key="index" class="border-b-2 mb-4">
              <div class="grid grid-cols-2 w-1/2">
                <div>
                  <div class="grid grid-rows-2">
                    <div class="text-black mb-2">
                      {{ getProxyName(proxy) }}
                    </div>
                    <div class="text-black-700">{{ proxy.email }}</div>
                  </div>
                </div>
                <div>
                  <button
                    @click.prevent="deleteProxyUserId = proxy.authorizedUserId"
                    class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full hover:bg-primary-default/50 items-center"
                  >
                    <TrashIcon class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block mr-1" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>
    <div class="grid py-4" v-if="addProxy">
      <card>
        <template v-slot>
          <div class="flex item-start">
            <div class="flex-shrink-0 content-center">
              <PlusIcon class="h-5 w-5 flex-shrink-0 text-pdsPrimaryColor cursor-pointer ml-2" aria-hidden="true" />
            </div>
            <div class="flex-1">
              <div class="text-2xl font-semibold leading-6 flex-1 mx-2">Volmachtgever toevoegen</div>
            </div>
          </div>
          <div class="grid my-2">
            <div class="pt-2">
              <div class="flex items-center px-2 py-2">
                <div class="w-2/4">
                  <p class="mb-2">Volledig e-mailadres van een volmachtgever</p>
                  <div class="grid grid-cols-2">
                    <div>
                      <v-input-group-simple-2
                        id="email"
                        v-model="searchProxyEmail"
                        type="text"
                        :rules="{
                          required: true,
                          email: true,
                          regex: /@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
                        }"
                      />
                    </div>
                    <div class="ml-4 mt-1 mb-1">
                      <button
                        @click.prevent="searchProxyUsers"
                        class="flex justify-center py-2 px-2 md:px-4 border border-primary-color shadow-sm text-xs md:text-sm lg:text-sm font-medium text-primary-color bg-white rounded-full hover:bg-primary-default/50 items-center"
                      >
                        <span>Zoeken</span>
                        <MagnifyingGlassIcon class="h-3 md:h-4 lg:h-4 w-3 md:w-4 lg:w-4 inline-block ml-1" />
                      </button>
                    </div>
                  </div>
                  <p class="mt-4">Begin met zoeken naar een volmachtgever op basis van een volledig e-mailadres.</p>
                </div>
              </div>
            </div>
            <div class="grid grid mx-2 my-4">
              <div v-if="searchProxyUserDetails.length > 0">
                <div v-for="(proxy, index) in searchProxyUserDetails" :key="index" class="border-b-2 mb-4">
                  <div class="grid grid-cols-2">
                    <div>
                      <div class="grid grid-rows-2">
                        <div class="text-black mb-2">
                          {{ getProxyName(proxy) }}
                        </div>
                        <div class="text-black-700">{{ proxy.email }}</div>
                      </div>
                    </div>
                    <div class="content-center justify-items-end">
                      <button
                        @click.prevent="addProxyUser(proxy.userId)"
                        class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full hover:bg-primary-default/50 items-center mr-2"
                      >
                        <PlusCircleIcon
                          class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block mr-1"
                          aria-hidden="true"
                        />
                        <span class="font-bold">Toevoegen</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showNoResult">
                <Alert
                  title="Let op!"
                  message="Opgelet! Did email adres is niet bij ons bekend als een voorschrijver. Uw volmachtgever moet voor het voorschrijfportaal een account hebben om als volmachtiger ingegeven te worden. Klik op “Collega toevoegen” om uw collega aan te melden."
                  type="error"
                ></Alert>
              </div>
            </div>
            <div class="flex flex-row justify-end gap-4 mt-4">
              <a
                :class="!showNoResult ? 'mr-4' : ''"
                class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
                @click.prevent="goBackToDepartment"
              >
                Annuleren
              </a>
              <button
                v-if="showNoResult"
                @click.prevent="$router.push('/collega-registreren')"
                class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full hover:bg-primary-default/50 items-center"
              >
                Collega toevoegen
              </button>
            </div>
          </div>
        </template>
      </card>
    </div>
  </div>
  <modal-dialog :modal-open-status="deleteProxyUserId !== null">
    <template #header>
      <div class="text-primary-default">
        <h2 class="text-lg font-bold my-2">Bevestiging Verwijderen</h2>
      </div>
    </template>
    <template #body> Weet u zeker dat u deze volmachtgever wil verwijderen? </template>
    <template #footer>
      <div class="flex flex-row justify-end gap-4 mt-4">
        <a
          class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
          @click.prevent="handleUpdate(false)"
        >
          Nee
        </a>
        <button
          @click.prevent="handleUpdate(true)"
          class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
        >
          Ja
        </button>
      </div>
    </template>
  </modal-dialog>
</template>
<script>
import VAccountGroupOutline from 'icons/AccountGroupOutline';
import { ref, watch, getCurrentInstance, onMounted } from 'vue';
import axios from 'axios';
import { useForm } from 'vee-validate';
import { TrashIcon, MagnifyingGlassIcon, PlusCircleIcon, PlusIcon } from '@heroicons/vue/20/solid';
export default {
  name: 'PrescriberProxyUserDetails',
  components: {
    VAccountGroupOutline,
    TrashIcon,
    MagnifyingGlassIcon,
    PlusCircleIcon,
    PlusIcon
  },
  props: {
    addProxyUserStatus: {
      type: Boolean,
      default: false
    },
    proxyUserDetails: {
      type: Array,
      required: true
    },
    userDetails: {
      type: Object,
      required: true
    },
    department: {
      type: Object,
      required: true
    }
  },
  emits: ['setDepartmentBreadCrumb', 'goBackToDepartment', 'showDepartmentProxyDetails'], // Declare emitted events
  setup(props, { emit }) {
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;
    const { validate } = useForm();
    const showProxy = ref(false);
    const deleteProxyUserId = ref(null);
    const addProxy = ref(false);
    const searchProxyUserDetails = ref([]);
    const searchProxyEmail = ref(null);
    const showNoResult = ref(false);

    onMounted(() => {
      const hasProxies = props.proxyUserDetails.length > 0;
      showProxy.value = hasProxies;
      addProxy.value = !hasProxies;
    });

    const searchProxyUsers = async () => {
      const result = await validate();
      if (result.valid) {
        axios.get('UserV2/GetAllProxyUsersByEmail?email=' + searchProxyEmail.value).then((response) => {
          if (response && response.data && response.data.length > 0) {
            searchProxyUserDetails.value = response.data;
          } else {
            showNoResult.value = true;
          }
        });
      }
    };

    const setDepartmentBreadCrumb = () => {
      emit('setDepartmentBreadCrumb');
    };

    const goBackToDepartment = () => {
      emit('goBackToDepartment');
      setDepartmentBreadCrumb();
    };

    const addProxyUser = (proxyUserId) => {
      axios
        .post('UserV2/AddProxyUser', {
          ppwrecid: props.userDetails.externalId + '-' + props.department.externalId,
          userId: proxyUserId
        })
        .then((response) => {
          if (response && response.data) {
            $emitter.emit('notification', {
              title: 'wijzigingen succesvol opgeslagen'
            });
            searchProxyUserDetails.value = [];
            emit('showDepartmentProxyDetails');
          }
        });
    };

    const handleUpdate = (isActive) => {
      if (isActive) {
        deleteProxyUser(deleteProxyUserId.value);
      } else {
        deleteProxyUserId.value = null;
      }
    };

    const getProxyName = (proxy) => {
      let proxyName = proxy.lastName;
      if (proxy.initials) {
        proxyName += ', ( ' + proxy.initials + ' )';
      }
      if (proxy.firstName) {
        proxyName += (proxy.initials ? ' ' : ', ') + proxy.firstName;
      }
      return proxyName;
    };

    const deleteProxyUser = (authorizedUserId) => {
      axios
        .post('UserV2/DeleteProxyUser', {
          authorizedUserId: authorizedUserId
        })
        .then((response) => {
          deleteProxyUserId.value = null;
          if (response && response.data) {
            $emitter.emit('notification', {
              title: 'wijzigingen succesvol opgeslagen'
            });
            if (props.proxyUserDetails.length == 1) {
              showProxy.value = false;
              addProxy.value = true;
            } else {
              emit('showDepartmentProxyDetails');
            }
          }
        });
    };

    watch(searchProxyEmail, (oldVal, newVal) => {
      if (newVal !== oldVal) {
        showNoResult.value = false;
        searchProxyUserDetails.value = [];
      }
    });

    watch(
      () => props.addProxyUserStatus,
      (newVal) => {
        addProxy.value = newVal;
        showProxy.value = !newVal;
      }
    );

    return {
      emit,
      showProxy,
      deleteProxyUser,
      deleteProxyUserId,
      handleUpdate,
      addProxy,
      addProxyUser,
      searchProxyEmail,
      searchProxyUsers,
      searchProxyUserDetails,
      getProxyName,
      showNoResult,
      goBackToDepartment,
      setDepartmentBreadCrumb
    };
  }
};
</script>
<style lang="scss" scoped>
.prescriberProxyUserDetails {
  color: $teal-darkest;
  :deep(.form-group-simple label) {
    color: $black;
    font-weight: 700;
    font-size: 16px;
  }
  .material-design-icon {
    fill: $teal-darkest;
  }
}
</style>
